import React, { createContext, useState, useEffect, useContext } from "react";
import { useAuth } from "utilities/auth";
import { isClient } from "utilities/userType";
import { apiRoutes, makeApiRequest } from "constants/apiRoutes";

const AdminCompanyContext = createContext();

export function AdminCompanyProvider({ children }) {
  const auth = useAuth();
  const [activeCompanyId, setActiveCompanyId] = useState(null);
  const [childCompanies, setChildCompanies] = useState([]);

  // Load from sessionStorage on mount
  useEffect(() => {
    const stored = sessionStorage.getItem("activeCompanyId");
    if (stored) {
      setActiveCompanyId(stored);
    }
  }, []);

  // Save to sessionStorage when value changes
  useEffect(() => {
    if (activeCompanyId) {
      sessionStorage.setItem("activeCompanyId", activeCompanyId);
    } else {
      sessionStorage.removeItem("activeCompanyId");
    }
  }, [activeCompanyId]);

  // Fetch child companies for client users
  useEffect(() => {
    if (!auth.user || !isClient(auth.user)) return;

    makeApiRequest(
      "get",
      apiRoutes.getCompanyChildren(auth.user.companyId),
      auth.user,
      auth.user.companyId
    )
      .then((res) => setChildCompanies(res.data || []))
      .catch(() => setChildCompanies([]));
  }, [auth.user?.companyId]);

  const isParentCompany = childCompanies.length > 0;

  return (
    <AdminCompanyContext.Provider
      value={{
        activeCompanyId,
        setActiveCompanyId,
        childCompanies,
        isParentCompany,
      }}
    >
      {children}
    </AdminCompanyContext.Provider>
  );
}

export function useAdminCompany() {
  return useContext(AdminCompanyContext);
}
